// import React, { useState, useEffect } from "react";
// import { useHistory } from 'react-router-dom';
// import { connect } from "react-redux";
// import axios from "axios";
// import { NavLink } from "react-bootstrap";
// import ConfirmDeleteModal from './ConfirmationModelDelete';

// const SubCategoryVrat = () => {
//   const [categories, setCategories] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
//   const history = useHistory();
//   const token = localStorage.getItem('authToken');
//   const getData = async () => {
//     try {
//       const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratsubcategory?page=${currentPage}&search=${searchQuery}`,{
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         }
//       });
//       setCategories(response?.data?.Varat);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleEdit = (id) => {
//     history.push(`/editvratsubcategory/${id}`);
//   };

//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(`https://samaj.aasmo.in/api/admin/vratsubcategory/${id}`,{
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         }
//       });
//       if (response) {
//         console.log("Deleted Successfully");
//         getData();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setShowModal(false);
//   };

//   const handleDeleteClick = (id) => {
//     setSelectedCategoryId(id);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     getData();
//   }, [currentPage, searchQuery]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };
//   const formatDescription = (description) => {
//     return description.length > 10 ? description.slice(0, 10) + '...' : description;
//   };
//   return (
//     <div className="col-lg-12">
//       <div className="card">
//         <div className="header">
//           <h2>Vrat Aur Tyohar Sub Category List</h2>
//         </div>
//         <div className="d-flex justify-content-between">
//           <div className="input-group m-b-10 col-lg-3">
//             <div className="input-group-prepend">
//               <span className="input-group-text">
//                 <i className="icon-magnifier"></i>
//               </span>
//             </div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search By Sub Category Name"
//               value={searchQuery}
//               onChange={handleSearch}
//             />
//           </div>
//         </div>
//         <div className="body table-responsive">
//           <table className="table table-hover">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Category Name</th>
//                 <th>Sub Category Name</th>
//                 <th>Sub Category Image</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody >
//               {categories.map((category, index) => (
//                 <tr key={category.id}>
//                   <td>{(currentPage - 1) * 10 + index + 1}</td>
//                   <td>{formatDescription(category?.category?.name)}</td>
//                   <td>{formatDescription(category.name)}</td>
//                   <td>
//                       <img src={`https://uma-classees.blr1.digitaloceanspaces.com/${category.image}`} width={50} height={50} className="rounded-circle user-photo" alt="Category" />
//                     </td>
//                   <td>
//                     <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
//                     &nbsp;&nbsp;
//                     <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//         <div className="body">
//           <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
//             <ul className="pagination">
//               <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage - 1)}
//                 >
//                   Previous
//                 </NavLink>
//               </li>
//               {[...Array(totalPages).keys()].map(page => (
//                 <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
//                   <NavLink
//                     to="#"
//                     className="page-link"
//                     onClick={() => handlePageChange(page + 1)}
//                   >
//                     {page + 1}
//                   </NavLink>
//                 </li>
//               ))}
//               <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage + 1)}
//                 >
//                   Next
//                 </NavLink>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </div>
//       <ConfirmDeleteModal
//         show={showModal}
//         handleClose={() => setShowModal(false)}
//         handleConfirm={() => handleDelete(selectedCategoryId)}
//       />
//     </div>
//   );
// };

// const mapStateToProps = ({ mailInboxReducer }) => ({});

// export default connect(mapStateToProps, {})(SubCategoryVrat);


import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';

const SubCategoryVrat = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratsubcategory?page=${currentPage}&search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      // --- CHANGE 1: Safety check for API response ---
      // Agar 'varat' array मौजूद hai, tabhi state update karein
      if (response.data && Array.isArray(response.data.varat)) {
        setCategories(response.data.varat);
        setTotalPages(response.data.totalPages);
      } else {
        // Agar data nahi hai, to state ko empty array par reset karein
        setCategories([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.log(error);
      setCategories([]); // Error aane par bhi state ko empty array set karein
      setTotalPages(1);
    }
  };

  const handleEdit = (id) => {
    history.push(`/editvratsubcategory/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/vratsubcategory/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      if (response) {
        console.log("Deleted Successfully");
        getData(); // Refresh data after deletion
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setCurrentPage(1); // Reset to first page on new search
    setSearchQuery(e.target.value);
  };
  
  const formatDescription = (description) => {
    if (!description) return ''; // Agar description nahi hai, to empty string return karein
    return description.length > 20 ? description.slice(0, 20) + '...' : description;
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Vrat Aur Tyohar Sub Category List</h2>
        </div>
        <div className="d-flex justify-content-between">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Sub Category Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Category Name</th>
                <th>Sub Category Name</th>
                <th>Sub Category Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {/* --- CHANGE 2: Safety check for rendering --- */}
              {/* .map chalaane se pehle check karein ki 'categories' ek array hai */}
              {Array.isArray(categories) && categories.map((category, index) => (
                <tr key={category.id}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>{formatDescription(category?.category?.name)}</td>
                  <td>{formatDescription(category.name)}</td>
                  <td>
                    {/* --- CHANGE 3: Use the full URL from the API --- */}
                    {/* Backend ab poora URL bhej raha hai, use seedhe use karein */}
                    <img src={category.image} width={50} height={50} className="rounded-circle user-photo" alt="Category" />
                  </td>
                  <td>
                    <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
                      
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(SubCategoryVrat);